import React from "react";

const emptyResults = () => (
  <div className="card w-75 mx-auto mt-4">
    <div className="card-body">
      <div className="card-title">
        <h4 className="fw-bold">No media outlets found matching this search.</h4>
      </div>
      <hr />
      <p>Try a publication name, a website, or a subject the outlet covers.</p>
      <p className="mb-0">A little tweak to your search could really sweeten your results!</p>
    </div>
  </div>
);

export default emptyResults;
